import axios from 'axios';
import { useState } from 'react';
import { Accordion, Button, Card } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { CONCURSOAPI } from '../../../../const';
import { finalize } from '../../../GlobalFeedback/feedbackSlice';

const DetallePostulacion = () => {
  const { idPuesto } = useParams();

  const idPuestoNumber = parseInt(idPuesto);
  const dispatch = useDispatch();

  const [setErrorMsg] = useState('');
  const [setRequisitosCargados] = useState([]);
  const [showCargaRequisitosModal, setShowCargaRequisitosModal] = useState(false);

  function handleShowCargaRequisitos() {
    obtenerRequisitosCargados();
    setShowCargaRequisitosModal(!showCargaRequisitosModal);
  }

  const obtenerRequisitosCargados = (idPuesto) => {
    axios
      .get(`${CONCURSOAPI}/concursos-publicados/requisitos/puesto/${idPuestoNumber}`)
      .then((res) => {
        console.log(res.data);
        setRequisitosCargados(res.data);
      })
      .catch((error) => {
        dispatch(finalize());
        if (error.response) {
          // Request made and server responded
          setErrorMsg(error.response.data.message);
        } else if (error.request) {
          // The request was made but no response was received
          setErrorMsg(error.request);
        } else {
          // Something happened in setting up the request that triggered an Error
          setErrorMsg(error.message);
        }
      });
  };

  return (
    <>
      <div className="row mt-3">
        <Button className="btn btn-primary m-3" type="button" onClick={handleShowCargaRequisitos}>
          Ver requisitos
        </Button>
        <button className="btn btn-primary m-3" type="button">
          Ver perfil
        </button>
        <button className="btn btn-primary m-3" type="button">
          Ver bases
        </button>
      </div>
      <Accordion>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="0">
              Miembros Comité
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="0">
            <Card.Body>MIEMBROS COMITE</Card.Body>
          </Accordion.Collapse>
        </Card>
        <Card>
          <Card.Header>
            <Accordion.Toggle as={Button} variant="link" eventKey="1">
              Listado de Actas Publicas
            </Accordion.Toggle>
          </Card.Header>
          <Accordion.Collapse eventKey="1">
            <Card.Body>LISTADO DE ACTAS PUBLICAS</Card.Body>
          </Accordion.Collapse>
        </Card>
      </Accordion>
    </>
  );
};

export default DetallePostulacion;
